import * as React from "react";
import styled from 'styled-components';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsHistogram from 'highcharts/modules/histogram-bellcurve';
import { apiProvider } from "@process-advisor/process-miner/api/apiProvider";

HighchartsHistogram(Highcharts);

const Graph = styled.div`
    padding-left: 10px;
    padding-right: 10px;
    overflow: auto;
`;

const Chart = (props) => {
   let axisTitle = props.axisTitle
   let numItems = props.chartData.length

   let chartOptions = {
    chart: {
        alignTicks: false,
        style: {
          fontFamily: 'system-ui'
,
        },
        borderWidth: 2,
        borderColor: '#E0E0E0'     
      },
      title: {
        text: '',
      },
      credits: {
            enabled: false,
        },
      legend: {
        enabled: false
      },


      xAxis: [{
        title: {
          text: ''
        },
        opposite: true,
        alignTicks: false,
        visible: false
      }, {
        title: {
          text: axisTitle
        },
        alignTicks: false,
        opposite: false,
      }, {
        linkedTo: 1,
        visible: false
      }],
    
    
      yAxis: [{
        title: {
          text: ''
        },
        opposite: true,
        visible: false
      }, {
        title: {
          text: '% Total'
        },
        endOnTick: false,
        opposite: false,
        labels: {
          formatter: function() {
            var number = ((this.value / numItems) * 100);
            return Highcharts.numberFormat(number, 1) + '%';
          }
        }
      }],
      lang: {
        noData: "Please select a source for the histogram data"
      },
      series: [{
        name: 'Histogram',
        type: 'histogram',
        id: 'h1',
        xAxis: 1,
        yAxis: 1,
        baseSeries: 's1',
        zIndex: -1,
           tooltip: {
             pointFormatter: function() {
               var number = ((this.y / numItems) * 100);
               return apiProvider.getHistogramType() + ': <b>' + this.y + '</b><br/>% Total: <b>' + Highcharts.numberFormat(number, 1) + ' %</b><br/>Range: <b>' + Highcharts.numberFormat(this.x, 2) + ' - ' + Highcharts.numberFormat(this.x2, 2)  + ' </b>';
             }
           }
           
      }, {
        name: 'Data',
        type: 'scatter',
        data: props.chartData,
        id: 's1',
        enableMouseTracking: false,
        marker: {
          radius: 0
        }
      }]
    };
    if (props.chartData.length === 0) {return null}
    return(
        <Graph>
            <HighchartsReact
                highcharts={Highcharts}
                options={chartOptions}
                oneToOne={true}
                containerProps={{ style: { height: '610px', width: '100%' } }}         
            />
        </Graph>
    );
}

export default Chart;